import { inject, Injectable } from "@angular/core";
import { ChangeUserEmailFacade } from "@modules/shared/modals/change-personal-info/domain/+state/change-user-email.facade";
import { ActivatedRouteSnapshot } from "@angular/router";

@Injectable({
	providedIn: "root"
})
export class ConfirmEmailGuard {
	private readonly changeUserEmailFacade = inject(ChangeUserEmailFacade);

	public canActivate(route: ActivatedRouteSnapshot): boolean {
		const code_id = route.queryParams.email_code;
		if (code_id !== undefined) {
			this.changeUserEmailFacade.onConfirmationEmail(code_id);
		}
		this.changeUserEmailFacade.navigateToMyAccount();
		return false;
	}
}
